import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/bcp/plans/new-recovery-procedure')({
  beforeLoad: () => {
    // TanStack Router expects redirect to be thrown as control flow.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/bcp/plans',
      search: {
        section: 'incident_response_plan',
        create: '1',
      },
      replace: true,
    });
  },
  component: () => null,
});
